<template>
  <v-dialog
    v-if="overlay"
    v-model="isShow"
    max-width="768"
    persistent
    content-class="ovelay-dialog"
    :fullscreen="isFullscreen"
    :transition="transition"
  >
    <component :is="overlay.component" v-bind="componentProps"></component>
  </v-dialog>
</template>

<script>
// import { getCurrentInstance } from '@vue/composition-api'
import { mapGetters, mapActions } from 'vuex'
import ProductsConfirmDisplay from '@/components/display/ProductsConfirmDisplay.vue'
import ProductsFileUploadDisplay from '@/components/display/ProductsFileUploadDisplay.vue'
// import BusinessFinderDisplay from '@/components/display/BusinessFinderDisplay.vue'
// import RegistrationDisplay from '@/components/display/RegistrationDisplay.vue'

export default {
  components: {
    ProductsConfirmDisplay,
    ProductsFileUploadDisplay,
    // BusinessFinderDisplay,
    // RegistrationDisplay,
  },
  setup() {
    // const internalInstance = getCurrentInstance()
    // const isMobile = internalInstance?.$vuetify?.breakpoint?.mobile === true

    // 일종의 Overlay 라우터 선언이라고 볼 수 있다.
    // 더 좋은 방법이 있으면 수정요망,,
    // keepAlive: overlay 전환 없을 시 유지
    const OVERLAYS = {
      '#products-confirm': {
        hash: '#products-confirm',
        name: 'ProductsConfirm',
        component: 'ProductsConfirmDisplay',
        transition: 'dialog-bottom-transition',
        isFullscreen: true,
        props: true,
        keepAlive: false,
      },
      '#products-upload': {
        hash: '#products-upload',
        name: 'ProductsUpload',
        component: 'ProductsFileUploadDisplay',
        transition: 'dialog-bottom-transition',
        isFullscreen: true,
        props: true,
        keepAlive: false,
      },
      // '#business-finder': {
      //   hash: '#business-finder',
      //   name: 'BusinessFinder',
      //   component: 'BusinessFinderDisplay',
      //   transition: 'dialog-bottom-transition',
      //   isFullscreen: true,
      //   props: true,
      //   keepAlive: false,
      // },
      // '#registration': {
      //   hash: '#registration',
      //   name: 'Registration',
      //   component: 'RegistrationDisplay',
      //   transition: 'dialog-bottom-transition',
      //   isFullscreen: true,
      //   props: true,
      //   keepAlive: false,
      // },
    }

    return {
      OVERLAYS,
    }
  },
  data() {
    return {
      isShow: false,
      overlay: null,
    }
  },
  computed: {
    ...mapGetters('overlay', {
      showDialog: 'isShowOverlay',
      overlayKey: 'getOverlay',
      getProps: 'getProps',
    }),
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
    componentProps() {
      if (this.overlay.props === true) {
        return this.getProps
      }
      return null
    },
    hash() {
      return this.overlay?.hash
    },
    isFullscreen() {
      return this.overlay?.isFullscreen || true
    },
    transition() {
      return this.overlay?.transition || 'dialog-bottom-transition'
    },
  },
  watch: {
    '$route.name'() {
      this.closeDialog()
    },
    'overlayKey'(v) {
      if (v) {
        this.overlay = this.OVERLAYS[v]
      } else {
        if (this.overlay.keepAlive !== true) {
          this.overlay = null
        }
      }
    },
    'showDialog': {
      immediate: true,
      handler(v) {
        this.isShow = v
      },
    },
    'isShow'(v) {
      const html = document.getElementsByTagName('html')[0]
      if (v) {
        html.classList.add('overflow-y-hidden')
        if (this.searchHash(this.hash) < 0) {
          history.pushState({ dialog: this.overlay?.name }, '', this.hash)
        }
      } else {
        html.classList.remove('overflow-y-hidden')
        if (this.searchHash('#') > -1) {
          history.back()
        } else {
          this.closeDialog()
        }
      }
    },
  },
  mounted() {
    window.onpopstate = (_) => {
      this.closeDialog()
    }
  },
  beforeDestroy() {
    window.onpopstate = null
  },
  methods: {
    ...mapActions('overlay', {
      closeDialog: 'closeOverlay',
      openDialog: 'openOverlay',
    }),
    hasOverlayKey(name) {
      const keys = Object.keys(this.OVERLAYS)
      return keys.indexOf(name) > -1
    },
    searchHash(text) {
      const hash = location?.hash
      return hash.indexOf(text)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-dialog__content--active {
  z-index: 10000001 !important;
}

::v-deep .ovelay-dialog {
  max-height: 100%;
  height: 100%;
}
</style>
